import { render, staticRenderFns } from "./VideoSectionSimple.vue?vue&type=template&id=124ec486"
import script from "./VideoSectionSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoSectionSimple.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports